var map = {
	"./1.png": 1009,
	"./10.png": 1637,
	"./2.png": 9898,
	"./3.png": 4003,
	"./4.png": 7756,
	"./5.png": 21,
	"./6.png": 7918,
	"./7.png": 6759,
	"./8.png": 5664,
	"./9.png": 3785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4379;